import * as React from 'react';
import AppContainer from './AppContainer';
import {CONTENT_TYPE} from '../../Config/appConfig';

class CompaniesContainer extends React.Component <{}, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.COMPANIES}/>
        );
    }
}

export default CompaniesContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/CompaniesContainer.tsx